export default "__VITE_ASSET__G0CkhE5y__"